export const CloudOnboarding = {
    previousOnboardingRequest: 'api/order/cpefinops/integration/1.0/cloudonboarding/existing-requests',
    tacRequest: 'api/order/snow/1.0/tac-requests',
    isaAPI: 'api/order/snow/1.0/isa-numbers',
    submitAPI: '1.0/cloud-onboarding/order',
};
export default CloudOnboarding;
